import { NgModule } from '@angular/core';
import { ProcessLinkDirective } from './process-link.directive';

@NgModule({
  declarations: [ProcessLinkDirective],
  exports: [ProcessLinkDirective],
})
export class ProcessLinkModule {}
